/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Trust_OverlineInputs */

const en_mk_team_trust_overline = /** @type {(inputs: Mk_Team_Trust_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YOU STAY IN CONTROL`)
};

const id_mk_team_trust_overline = /** @type {(inputs: Mk_Team_Trust_OverlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KENDALI TETAP DI TANGANMU`)
};

/**
* | output |
* | --- |
* | "YOU STAY IN CONTROL" |
*
* @param {Mk_Team_Trust_OverlineInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_trust_overline = /** @type {((inputs?: Mk_Team_Trust_OverlineInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Trust_OverlineInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_trust_overline(inputs)
	return en_mk_team_trust_overline(inputs)
});